module.exports = new __parcel__URL__("wbd-favicon-32.4b7dd6d3.png").toString();